export default "__VITE_ASSET__B6U$ewqT__"